package com.hyperether.goodjob.com.hyperether.goodjob.util

import js.buffer.ArrayBuffer
import kotlinx.browser.document
import org.khronos.webgl.Uint8Array
import org.khronos.webgl.get
import org.w3c.dom.HTMLInputElement
import org.w3c.files.File
import org.w3c.files.FileReader

private const val IMAGE_MIME_TYPES = "image/jpeg,image/jpg,image/png"
private const val IMAGE_OR_PDF_MIME_TYPES = "image/jpeg,image/jpg,image/png,application/pdf"

class FileUtilJsMain {

    fun openFilePicker(
        isSignature: Boolean = false,
        multiple: Boolean = false,
        onFilesSelected: (List<File>) -> Unit
    ) {
        val input = document.createElement("input") as HTMLInputElement
        input.type = "file"
        input.accept =
            if (isSignature) {
                IMAGE_MIME_TYPES
            } else {
                IMAGE_OR_PDF_MIME_TYPES
            }
        input.style.display = "none"
        input.multiple = multiple

        input.onchange = {
            val files = input.files
            if (files != null && files.length > 0) {
                val fileList = buildList {
                    for (i in 0 until files.length) {
                        files.item(i)?.let {
                            add(it)
                        }
                    }
                }
                onFilesSelected(fileList)
            }
        }

        document.body?.appendChild(input)
        input.click()
        document.body?.removeChild(input)
    }

    fun readFileAsByteArray(file: File, onResult: (ByteArray) -> Unit) {
        val reader = FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = {
            val result = reader.result
            if (result is ArrayBuffer) {
                val uint8Array = js("new Uint8Array(result)") as Uint8Array
                val byteArray = ByteArray(uint8Array.length) { index ->
                    uint8Array[index]
                }
                onResult(byteArray)
            }
        }
    }
}